import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, shallowEquals, contains } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";



type Entity = models.DocumentacionModel;

/**Devuelve true si se debe de mostrar la alerta de un destino diferente en la parte de destino seleccionado y en la de paquetes y sobres */
function alertaDestinoDiferente(model: Entity): boolean {
    if (model.servicios.Sobres.length == 0 && model.servicios.Paquetes.length == 0 || model.IdDireccionDestino == null || model.IdSucursalDestino == null) {
        return false;
    }

    const getDestino = (x: {
        IdDireccionDestino: number,
        IdSucursalDestino: number
    }) => ({
        idDireccion: x.IdDireccionDestino,
        idSucursal: x.IdSucursalDestino
    });

    var destinos =
        [
            ...model.servicios.Paquetes.map(getDestino),
            ...model.servicios.Sobres.map(getDestino)
        ];

    const destinoSeleccionado = {
        idDireccion: model.IdDireccionDestino,
        idSucursal: model.IdSucursalDestino
    };

    return !contains(destinos, destinoSeleccionado, shallowEquals);
}

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}


export class AlertaDestinoDiferente extends React.PureComponent<Props>  {
    
    render() {
        const alerta = alertaDestinoDiferente(this.props.value);
        return (
            alerta &&
            <div className="alert alert-warning">
                <label>Destino no especificado en los paquetes</label>
                <br />
                Ningun paquete o sobre tiene el destino seleccionado arriba.
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/alertaDestinoDiferente.tsx